<template>
    <l-layout :layout="['xs12']">
          <v-card>
            <l-data-table
              ref="blackVehicleList"
            :headers="this.header"
            :title-slot="true"
            search-text="搜索车辆号牌"
            :filter-items="filterItems"
            :get-data-func="getCenterAreaList"
            clickable
            @click:row="goToVehicleDetails($event.item.plateNumber)"
            >
              <template slot="title">
                <span class="pl-2 pr-4"> 限定性区域车辆通行记录 </span>
                <v-radio-group mandatory row v-model="isHistory">
                  <v-radio :value="false" label="当前"></v-radio>
                  <v-radio :value="true" label="历史"></v-radio>
                </v-radio-group>
              </template>
              <!-- <template slot="item.orderId" slot-scope="{item}">
                <v-tooltip bottom v-if="item && item.orderId">
                  <v-btn slot="activator" icon @click="goToReservationDetails(item)">
                    <v-icon small>mdi-file-document-outline</v-icon>
                  </v-btn>
                  <span>预约详情</span>
                </v-tooltip>
                <v-btn v-else icon disabled>
                  <v-icon small>mdi-file-document-outline</v-icon>
                </v-btn>
              </template> -->
              <template slot="row-action" slot-scope="{item}">
                <td @click.stop style="
                  display: flex;
                  align-items: center;
                  flex-wrap: nowrap;
                  flex-shrink: 0;
                  min-width: 120px;
                ">
                  <v-tooltip bottom >
                    <v-btn slot="activator" icon @click="goToReservationDetails(item)">
                      <v-icon small>mdi-file-document-outline</v-icon>
                    </v-btn>
                    <span>预约详情</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!isHistory">
                    <v-btn slot="activator" icon @click="unFreezeCenterAreaVehicle(item)" :disabled="item.status === 1">
                      <v-icon small>mdi-lock</v-icon>
                    </v-btn>
                    <span>解除冻结</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="!isHistory">
                    <v-btn slot="activator" icon @click="deleteCenterAreaVehicle(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                    <span>删除</span>
                  </v-tooltip>

                </td>
              </template>
            </l-data-table>
          </v-card>
    </l-layout>
  </template>
  <script>
  import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
  import {time} from '../../ladmin/utils/time'
  export default {
    name: 'centerArea',
    components: {LDataTable},
    data () {
      return {
        isHistory: false,
        header: [
          {text: '车辆号牌', align: 'left', value: 'plateNumber', sortable: false,
           f: (v) => v ? v : 'N/A'},
          {text: '预约人', align: 'left', value: 'applicantName', sortable: false,
           f: (v) => v || 'N/A'},
          {text: '预约人二级单位', align: 'left', value: 'applicantOrgName', sortable: false,
           f: (v, item) => v || item.applicantOrgId || 'N/A'},
          {text: '手机号码', align: 'left', value: 'ownerPhone', sortable: false,
           f: (v) => v ? v : 'N/A'},
          {text: '所在园区', align: 'left', value: 'inTargetParkName', sortable: false,
           f: (v) => v ? v : 'N/A'},
          {text: '入场卡口', align: 'left', value: 'inGateName', sortable: false,
           f: (v) => v ? v : 'N/A'},
          {text: '入场时间', align: 'left', value: 'inTime', sortable: false,
           f: (v) => v ? time.stringify(v) : 'N/A'},
          {text: '出场卡口', align: 'left', value: 'outGateName', sortable: false,
           f: (v) => v ? v : 'N/A'},
          {text: '出场时间', align: 'left', value: 'outTime', sortable: false,
           f: (v) => v ? time.stringify(v) : 'N/A'},
          {text: '允许最晚出场时间', align: 'left', value: 'scheduleEndTime', sortable: false,
           f: (v) => v ? time.stringify(v) : 'N/A'},
          {text: '个人/单位预约', align: 'left', value: 'orderType', sortable: false,
            f: (v) => v ? v : 'N/A'},
          {text: '状态', align: 'left', value: 'status', sortable: false, width: '80px',
           f: (v) => {
             if (v === undefined || v === null) return 'N/A';
             if (this.isHistory) {
               return v === 1 ? '离场' : '冻结';
             } else {
               return v === 1 ? '在场' : '冻结';
             }
           }},
          {text: '操作', align: 'center', value: '', sortable: false}
        ],
        filterItems: [
          {
            key: 'ownerPhone',
            value: '',
            label: '搜索手机号码',
            type: 'text',
            layout: ['xs12', 'sm4'],
          },
          {
            key: 'orderType',
            value: '',
            label: '搜索预约类型',
            type: 'text',
            layout: ['xs12', 'sm4'],
          },
          {
            key: 'inTargetParkName',
            value: '',
            label: '所在园区（需完整填写）',
            type: 'text',
            layout: ['xs12', 'sm4'],
          },
          {
            key: 'passTime',
            value: {},
            label: '入场通行时间',
            type: 'duration',
            layout: ['xs12', 'sm6'],
            f: v => time.stringify(v),
            range: true
          },
          {
            key: 'status',
            value: '',
            label: '状态',
            type: 'select',
            items: [
              {text: '全部', value: ''},
              {text: '在场', value: '1'},
              {text: '冻结', value: '0'}
            ],
            layout: ['xs12', 'sm6'],
          }
        ],
      }
    },
    watch: {
      isHistory() {
        this.$refs.blackVehicleList.refresh()
      }
    },
    methods: {
      async getCenterAreaList ({pagination, sortStack, filterItems = [], search}) {
        let searchParam = {
        'history': this.isHistory,
        'plateNumber': search,
        'ownerPhone': filterItems[0].value,
        'orderType': filterItems[1].value,
        'inTargetParkName': filterItems[2].value,
        'passStartTime': filterItems[3].value && filterItems[3].value.startDatetime ? time.toTimeStamp(filterItems[3].value.startDatetime) : '',
        'passEndTime': filterItems[3].value && filterItems[3].value.endDatetime ? time.toTimeStamp(filterItems[3].value.endDatetime) : '',
        'status': filterItems[4].value,
        'page': pagination.page,
        'size': pagination.rowsPerPage,
        }
        let res = await this.$store.dispatch('passControl/getCenterAreaList', {pagination: pagination, searchParam: searchParam})
        if (res.data.status === 1) {
          return {items: res.data.data.content, amount: res.data.data.totalElements}
        }
        else {
          this.$L.alert('error', {message: '查询失败，原因：' + res.data.msg})
        }
      },
      async unFreezeCenterAreaVehicle (item) {
        let {res, close} = await this.$L.confirm({title: '提示', text: '是否解除车辆' + item.plateNumber + '的冻结状态？该操作会删除当前记录，后续可在历史记录中查询'})
        if (res) {
          try {
            let searchParam = {
              'plateNumbers': [item.id],
            }
            let res = await this.$store.dispatch('passControl/unFreezeCenterAreaVehicle', {searchParam})
            if (res.data.status === 1) {
              this.$L.alert('success', {message: '解冻成功'})
              this.$refs.blackVehicleList.refresh()
            }
            else {
              this.$L.alert('error', {message: '解冻失败，原因：' + res.data.msg})
            }
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      async deleteCenterAreaVehicle (item) {
        let {res, close} = await this.$L.confirm({
          title: '警告',
          text: '请确认是否删除车辆【' + item.plateNumber + '】的入场记录？此操作仅适用于系统异常处理，不可恢复！'
        })
        if (res) {
          try {
            let searchParam = {
              'plateNumbers': [item.id],
            }
            // 使用与解除冻结相同的接口
            let res = await this.$store.dispatch('passControl/deleteCenterAreaVehicle', {searchParam})
            if (res.data.status === 1) {
              this.$L.alert('success', {message: '删除成功'})
              this.$refs.blackVehicleList.refresh()
            }
            else {
              this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
            }
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      hasOrderId(item) {
        return item && typeof item === 'object' && 'orderId' in item && item.orderId;
      },
      goToVehicleDetails (plateNumber) {
        if (plateNumber) {
          this.$router.push({
            path: '/statistics/vehicle/' + plateNumber
          })
        }
      },
      goToReservationDetails (item) {
        if (this.hasOrderId(item)) {
          this.$router.push({
            path: '/reservation/organization/' + item.plateNumber + '/readonly',
            query: {
              id: item.orderId,
            }
          })
        } else {
          this.$L.alert('warning', {message: '没有关联的预约信息'})
        }
      },
    },
  }
  </script>
